module.exports = __webpack_public_path__ + "img/real_land_4.449a268d.png";